import { Injectable } from '@angular/core';
import { App, AppInfo, BackButtonListener, RestoredListener, StateChangeListener, URLOpenListener } from '@capacitor/app';
import { PluginListenerHandle } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class AppWrapper {
  async getAppInfo(): Promise<AppInfo> {
    const appInfo = await App.getInfo();
    return appInfo;
  }

  async addAppStateChangeListener(listenerFunc: StateChangeListener): Promise<PluginListenerHandle> {
    const listenerHandle = await App.addListener('appStateChange', listenerFunc);
    return listenerHandle;
  }

  async addPauseListener(listenerFunc: () => void): Promise<PluginListenerHandle> {
    const listenerHandle = await App.addListener('pause', listenerFunc);
    return listenerHandle;
  }

  async addResumeListener(listenerFunc: () => void): Promise<PluginListenerHandle> {
    const listenerHandle = await App.addListener('resume', listenerFunc);
    return listenerHandle;
  }

  async addUrlOpenListener(listenerFunc: URLOpenListener): Promise<PluginListenerHandle> {
    const listenerHandle = await App.addListener('appUrlOpen', listenerFunc);
    return listenerHandle;
  }

  async addAppRestoredListener(listenerFunc: RestoredListener): Promise<PluginListenerHandle> {
    const listenerHandle = await App.addListener('appRestoredResult', listenerFunc);
    return listenerHandle;
  }

  async addBackButtonListener(listenerFunc: BackButtonListener): Promise<PluginListenerHandle> {
    const listenerHandle = await App.addListener('backButton', listenerFunc);
    return listenerHandle;
  }

  async removeAllListeners(): Promise<void> {
    const removeAllListeners = await App.removeAllListeners();
    return removeAllListeners;
  }
}
